import { useSyncExternalStore } from "react";
import { DEMO_RESET_EVENT } from "../lib/demo-session";

export type FakeWorkflowInstance = {
  id: string;
  workflow: string;
  entityType: string;
  state: string;
  status: string;
  pending: number;
  failed: number;
  updatedAt: string;
};

const STORAGE_KEY = "yatta:workflow-instances:demo";
const listeners = new Set<() => void>();
let rows: FakeWorkflowInstance[] = readRows();
let version = 0;

function readRows(): FakeWorkflowInstance[] {
  if (typeof window === "undefined") return [];
  try {
    const value: unknown = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? "[]");
    return Array.isArray(value) ? (value as FakeWorkflowInstance[]) : [];
  } catch {
    return [];
  }
}

function notify() {
  version += 1;
  listeners.forEach((listener) => listener());
}

function persist() {
  if (typeof window === "undefined") return;
  try {
    if (rows.length) window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Session storage may be unavailable in private or restricted browser modes.
  }
}

export function subscribeFakeWorkflowStore(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getFakeWorkflowStoreVersion() {
  return version;
}

export function useFakeWorkflowStoreVersion() {
  return useSyncExternalStore(
    subscribeFakeWorkflowStore,
    getFakeWorkflowStoreVersion,
    getFakeWorkflowStoreVersion,
  );
}

export function listFakeWorkflowInstances() {
  return [...rows];
}

export function createFakeWorkflowInstance(input: { workflow: string; entityType: string }) {
  const row: FakeWorkflowInstance = {
    id: `workflow-demo-${Date.now()}-${rows.length + 1}`,
    workflow: input.workflow,
    entityType: input.entityType,
    state: "AGUARDANDO_REVISÃO",
    status: "SIMULAÇÃO",
    pending: 1,
    failed: 0,
    updatedAt: new Date().toLocaleString("pt-BR"),
  };
  rows = [...rows, row];
  persist();
  notify();
  return row;
}

export function resetFakeWorkflowInstances() {
  rows = [];
  persist();
  notify();
}

if (typeof window !== "undefined") {
  window.addEventListener(DEMO_RESET_EVENT, resetFakeWorkflowInstances);
}
